import {
  createService,
  getPaginatedResponseSchema,
  z,
} from '@bonanza-social/toolkit/api';
import { PromoSchema } from './PromosService.schemas';

export const anonPromosService = createService({
  getPublicPromos: {
    method: 'GET',
    url: '/Lobby/promotions',
    responseSchema: getPaginatedResponseSchema(PromoSchema),
    headers: {
      'X-Feature-EnableMetaGameRewards': 'true',
    },
  },
});

export const userPromosService = createService(
  {
    getPromos: {
      method: 'GET',
      url: '/promotions',
      responseSchema: getPaginatedResponseSchema(PromoSchema),
      headers: {
        'X-Feature-UseNewReferral': 'true',
        'X-Feature-EnableTokenRewards': 'true',
        'X-Feature-EnableMetaGameRewards': 'true',
      },
    },
    optIn: {
      method: 'POST',
      url: ({ promoId }: { promoId: number }) => `/promotions/${promoId}/optin`,
      responseSchema: z.object({}).optional(),
    },
    optOut: {
      method: 'POST',
      url: ({ promoId }: { promoId: number }) =>
        `/promotions/${promoId}/optout`,
      responseSchema: z.object({}).optional(),
    },
  },
  ({ userId }) => `/Players/${userId}`,
);

export default {
  ...anonPromosService,
  ...userPromosService,
};
